(function () {
  if (window.__sampleDrawerInitialized) return;
  window.__sampleDrawerInitialized = true;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function toAbsoluteUrl(url) {
    if (!url) return "";
    if (url.startsWith("//")) return window.location.protocol + url;
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return window.location.origin + url;
  }

  async function fetchCollectionProducts(handle) {
    const all = [];
    const limit = 250;
    let page = 1;
    let keepGoing = true;

    while (keepGoing && page <= 20) {
      const response = await fetch(`/collections/${handle}/products.json?limit=${limit}&page=${page}`, {
        credentials: "same-origin"
      });

      if (!response.ok) {
        throw new Error("Collection products could not be loaded.");
      }

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      all.push.apply(all, products);

      if (products.length < limit) {
        keepGoing = false;
      } else {
        page += 1;
      }
    }

    return all;
  }

  document.addEventListener("DOMContentLoaded", function () {
    const config = window.sampleDrawerConfig || {};
    const drawer = document.querySelector("[data-sample-drawer]");
    const backdrop = document.querySelector("[data-sample-drawer-backdrop]");

    if (!drawer || !backdrop || !config.sampleBoxVariantId) return;

    const closeButtons = drawer.querySelectorAll("[data-sample-drawer-close]");
    const productListEl = drawer.querySelector("[data-sample-product-list]");
    const selectedListEl = drawer.querySelector("[data-sample-selected-list]");
    const selectedEmptyEl = drawer.querySelector("[data-sample-selected-empty]");
    const selectedCountEl = drawer.querySelector("[data-sample-selected-count]");
    const searchInput = drawer.querySelector("[data-sample-search]");
    const errorEl = drawer.querySelector("[data-sample-error]");
    const submitBtn = drawer.querySelector("[data-sample-add-to-cart]");

    const maxSamples = Number(config.maxSamples || 3);
    const selected = new Map();

    let allProducts = [];
    let filteredProducts = [];
    let isLoadingProducts = false;
    let productsLoaded = false;
    let isSubmitting = false;

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = "";
    }

    function openDrawer() {
      drawer.classList.add("is-open");
      backdrop.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("overflow-hidden");
      loadProductsIfNeeded();
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("overflow-hidden");
      clearError();
    }

    function normalizeProduct(product) {
      const firstVariant = Array.isArray(product.variants) && product.variants.length ? product.variants[0] : {};
      const imageSrc =
        product.image && product.image.src
          ? product.image.src
          : Array.isArray(product.images) && product.images.length
          ? product.images[0].src || product.images[0]
          : "";

      return {
        id: String(product.id),
        handle: product.handle || "",
        title: product.title || "",
        url: `/products/${product.handle}`,
        image: toAbsoluteUrl(imageSrc),
        sku: firstVariant && firstVariant.sku ? firstVariant.sku : "",
        available: product.available !== false
      };
    }

    function renderSelected() {
      const items = Array.from(selected.values());

      if (selectedCountEl) {
        selectedCountEl.textContent = `${items.length}/${maxSamples}`;
      }

      if (selectedEmptyEl) {
        selectedEmptyEl.hidden = items.length > 0;
      }

      if (!items.length) {
        selectedListEl.innerHTML = "";
      } else {
        selectedListEl.innerHTML = items
          .map(function (item) {
            return `
              <div class="sample-drawer__selected-card">
                <button
                  type="button"
                  class="sample-drawer__selected-remove"
                  data-remove-selected="${escapeHtml(item.id)}"
                  aria-label="Verwijderen"
                >&times;</button>
                <div class="sample-drawer__selected-image">
                  ${
                    item.image
                      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
                      : ""
                  }
                </div>
                <div class="sample-drawer__selected-name">${escapeHtml(item.title)}</div>
              </div>
            `;
          })
          .join("");
      }

      renderProductList();
    }

    function renderProductList() {
      if (isLoadingProducts) {
        productListEl.innerHTML = `<div class="sample-drawer__loading">Producten worden geladen...</div>`;
        return;
      }

      if (!filteredProducts.length) {
        productListEl.innerHTML = `<div class="sample-drawer__no-results">Geen producten gevonden.</div>`;
        return;
      }

      const isLimitReached = selected.size >= maxSamples;

      productListEl.innerHTML = filteredProducts
        .map(function (item) {
          const alreadySelected = selected.has(item.id);
          const disableAdd = !alreadySelected && isLimitReached;
          const buttonText = alreadySelected ? "Geselecteerd" : "Toevoegen";

          return `
            <div class="sample-drawer__item">
              <div class="sample-drawer__item-image">
                ${
                  item.image
                    ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
                    : ""
                }
              </div>
              <div class="sample-drawer__item-title">${escapeHtml(item.title)}</div>
              <div class="sample-drawer__item-actions">
                <button
                  type="button"
                  class="sample-drawer__item-btn ${alreadySelected ? "is-selected" : ""}"
                  data-select-sample="${escapeHtml(item.id)}"
                  ${disableAdd ? "disabled" : ""}
                >
                  ${buttonText}
                </button>
              </div>
            </div>
          `;
        })
        .join("");
    }

    function applySearch() {
      const keyword = (searchInput.value || "").trim().toLowerCase();

      filteredProducts = allProducts.filter(function (item) {
        if (!keyword) return true;
        return (
          item.title.toLowerCase().includes(keyword) ||
          item.handle.toLowerCase().includes(keyword) ||
          (item.sku || "").toLowerCase().includes(keyword)
        );
      });

      renderProductList();
    }

    function addSample(item) {
      clearError();

      if (selected.has(item.id)) return;

      if (selected.size >= maxSamples) {
        showError(`Je kunt maximaal ${maxSamples} samples kiezen. Verwijder eerst een sample.`);
        return;
      }

      selected.set(item.id, item);
      renderSelected();
    }

    function removeSample(id) {
      selected.delete(String(id));
      renderSelected();
      clearError();
    }

    function addCurrentProductFromTrigger(trigger) {
      if (!trigger) return;

      const productId = trigger.getAttribute("data-current-product-id");
      if (!productId) return;

      const currentItem = {
        id: String(productId),
        handle: trigger.getAttribute("data-current-product-handle") || "",
        title: trigger.getAttribute("data-current-product-title") || "",
        url: trigger.getAttribute("data-current-product-url") || "",
        image: toAbsoluteUrl(trigger.getAttribute("data-current-product-image") || ""),
        sku: trigger.getAttribute("data-current-product-sku") || "",
        available: true
      };

      addSample(currentItem);
    }

    async function loadProductsIfNeeded() {
      if (productsLoaded || isLoadingProducts) return;

      isLoadingProducts = true;
      renderProductList();

      try {
        const rawProducts = await fetchCollectionProducts(config.collectionHandle || "plinten");

        allProducts = rawProducts
          .map(normalizeProduct)
          .filter(function (item) {
            return item.handle && item.handle !== (config.sampleBoxHandle || "sample-box");
          });

        const uniqueMap = new Map();
        allProducts.forEach(function (item) {
          uniqueMap.set(item.id, item);
        });
        allProducts = Array.from(uniqueMap.values());

        filteredProducts = allProducts.slice();
        productsLoaded = true;
      } catch (error) {
        productListEl.innerHTML = `<div class="sample-drawer__no-results">Producten konden niet worden geladen.</div>`;
      } finally {
        isLoadingProducts = false;
        renderProductList();
      }
    }

    function buildProperties() {
      const items = Array.from(selected.values());

      const skus = items
        .map(function (item) {
          return String(item.sku || "").trim();
        })
        .filter(Boolean);

      return {
        "_sample_box": "true",
        "_sample_count": String(items.length),
        "Sample SKU's": skus.join(", ")
      };
    }

    async function addSampleBoxToCart() {
      clearError();

      if (!selected.size) {
        showError("Voeg minimaal 1 sample toe.");
        return;
      }

      if (isSubmitting) return;
      isSubmitting = true;
      submitBtn.disabled = true;

      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Bezig...";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            items: [
              {
                id: Number(config.sampleBoxVariantId),
                quantity: 1,
                properties: buildProperties()
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error("Cart add failed");
        }

        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              source: "sample-drawer"
            }
          })
        );

        submitBtn.textContent = "Samples toegevoegd";

        setTimeout(function () {
        window.location.href = "/cart";
        }, 300);
      } catch (error) {
        submitBtn.textContent = originalText;
        showError("Er is een fout opgetreden. Probeer opnieuw.");
      } finally {
        isSubmitting = false;
        submitBtn.disabled = false;
      }
    }

    document.addEventListener("click", function (event) {
      const openTrigger = event.target.closest("[data-sample-drawer-open]");
      const closeTrigger = event.target.closest("[data-sample-drawer-close]");
      const selectTrigger = event.target.closest("[data-select-sample]");
      const removeTrigger = event.target.closest("[data-remove-selected]");

      if (openTrigger) {
        event.preventDefault();
        openDrawer();
        addCurrentProductFromTrigger(openTrigger);
        return;
      }

      if (closeTrigger || event.target === backdrop) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (selectTrigger) {
        event.preventDefault();
        const productId = String(selectTrigger.getAttribute("data-select-sample"));
        const item = allProducts.find(function (product) {
          return product.id === productId;
        });

        if (!item) return;

        if (selected.has(productId)) {
          removeSample(productId);
        } else {
          addSample(item);
        }
        return;
      }

      if (removeTrigger) {
        event.preventDefault();
        removeSample(removeTrigger.getAttribute("data-remove-selected"));
      }
    });

    if (searchInput) {
      searchInput.addEventListener("input", applySearch);
    }

    if (submitBtn) {
      submitBtn.addEventListener("click", addSampleBoxToCart);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });

    renderSelected();
    renderProductList();
  });
})();